import { Component, Input } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-history-logs',
  templateUrl: './history-logs.component.html',
  styleUrls: ['./history-logs.component.scss'],
})
export class HistoryLogsComponent {
  @Input() logs: any[];
  @Input() title;
  @Input() maxHeight;

  constructor(public transloco: TranslocoService) {
    setTimeout(() => {}, 1500);
  }
}
